import { render } from "./SelectorCaducidad.vue?vue&type=template&id=bd32a5c6&scoped=true"
import script from "./SelectorCaducidad.vue?vue&type=script&lang=js"
export * from "./SelectorCaducidad.vue?vue&type=script&lang=js"

import "./SelectorCaducidad.vue?vue&type=style&index=0&id=bd32a5c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd32a5c6"]])

export default __exports__